import api from '../../services/api';
import moment from 'moment';
import * as type from '../types';

export default {
    namespaced: true,
    state: {
        headers: [
            {
                text: 'Brand',
                value: 'brandName',
                sortable: true,
                // width: '150'
            },
            {
                text: 'Segment',
                value: 'segment',
                sortable: true,
                // width: '150'
            },
            {
                text: 'PO #',
                value: 'purchaseOrderNumber',
                sortable: true,
                // width: '150'
            },
            {
                text: 'Invoice #',
                value: 'invoiceNumber',
                sortable: true,
                // width: '150'
            },
            {
                text: 'Invoice Date',
                value: 'invoiceDate',
                sortable: true,
                // width: '150'
            },
            {
                text: 'Net Terms',
                value: 'invoiceTerms',
                sortable: true,
                // width: '150'
            },
        ],
        records: [],
        loading: false,
        authenticated: false
    },
    getters: {
        authenticated: state => state.authenticated,
        getHeaders: state => state.headers,
        getRecords: state => state.records
    },
    mutations: {
        [type.GET_INVOICE_RECORDS]: (state, payload) => state.records = payload,
        [type.QB_SET_AUTH]: state => state.authenticated = true,
        [type.QB_REMOVE_AUTH]: state => state.authenticated = false,
    },
    actions: {
        [type.GET_INVOICE_RECORDS]: async ({commit}) => {
            commit(`global/${type.SET_LOADING}`, null, { root: true });
            commit(type.GET_INVOICE_RECORDS, []);

            try {
                let response = await api.get(`/get/invoice-information`);
                if(response.status === 200){
                    let result = response.data.map(e => {
                        let dateProcessed = moment(e.dateProcessed).utcOffset('+08:00').format('MM/DD/YYYY');
                        let dropShipFee = e.dropShipFee === undefined ? '' : e.dropShipFee;
                        let type = e.type === 'fileFeed' ? 'Template' : e.type
                        return {
                            ...e,
                            dateProcessed,
                            dropShipFee,
                            type
                        }
                    });
                    
                    commit(type.GET_INVOICE_RECORDS, result);
                    commit(`global/${type.REMOVE_LOADING}`, 'success', { root: true })
                }
            } catch (error) {
                commit(type.GET_INVOICE_RECORDS, []);
                commit(`global/${type.REMOVE_LOADING}`, 'error', { root: true });
                commit(`global/${type.SET_MESSAGE}`, { type: 'error', message: error.data.err.msg }, { root: true });
            }
        },
        [type.QB_CONNECT]: async ({commit}) => {
            commit(`global/${type.SET_LOADING}`, null, { root: true });
            try {
                let response = await api.get(`/quickbooks/retrieveToken`);
                if(response.data.token.access_token){
                    commit(type.QB_SET_AUTH);
                }else{
                    commit(type.QB_REMOVE_AUTH);
                }
                commit(`global/${type.REMOVE_LOADING}`, 'success', { root: true })
            } catch (error) {
                commit(`global/${type.REMOVE_LOADING}`, 'error', { root: true })
                commit(type.QB_REMOVE_AUTH);
            }
        },
        [type.QB_DISCONNECT]: async ({commit}) => {
            commit(`global/${type.SET_LOADING}`, null, { root: true });
            try {
                let response = await api.get(`/quickbooks/disconnect`);
                if(response.status === 200){
                    commit(type.QB_REMOVE_AUTH);
                    commit(`global/${type.SET_NOTIFICATION}`, { type: 'success', message: 'You are now disconnected.' },{ root: true });
                }
            }finally{
                commit(`global/${type.REMOVE_LOADING}`, 'success', { root: true })
            }
        },
        [type.QB_OPEN_AUTH]: () => {
            window.open(process.env.VUE_APP_QB_AUTH_URI, "_self");
        }
    }
}